import { render, staticRenderFns } from "./Streaks.vue?vue&type=template&id=a0caec50&scoped=true"
import script from "./Streaks.vue?vue&type=script&lang=js"
export * from "./Streaks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0caec50",
  null
  
)

export default component.exports